import { Box, Grid, Typography } from "@mui/material";
import React from "react";

export interface HomeImageProps {
    title: string;
    caption?: string;
}

export function HomeImage(props: HomeImageProps) {
    const { title, caption = "" } = props;

    return (
        <Box
            sx={{
                height: "50vh",
                overflow: "hidden",
                position: "relative",
                margin: 0,
                padding: 0,
            }}
        >
            <Grid
                container
                direction="column"
                spacing={2}
                alignItems="center"
                justifyContent="center"
                sx={{
                    backgroundImage: `url(/background.jpg)`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "top",
                    width: "100%",
                    color: "white",
                    padding: 2,
                    transition: "opacity 1.5s ease-in-out",
                    height: "100%",
                    position: "absolute",
                    margin: 0,
                }}
            >
                <Grid item>
                    <Typography variant="h3" align="center">
                        {title}
                    </Typography>
                </Grid>
                <Grid item>
                    <Box
                        sx={{
                            bgcolor: "secondary.main",
                            minWidth: 340,
                            minHeight: 2,
                        }}
                    />
                </Grid>
                <Grid item>
                    <Typography variant="h6" align="center">
                        {caption}
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    );
}
